<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/news'">GizmO News</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add news</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit news</span>
      }
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row g-3 mb-3">
        <div class="col-4">
          <label for="title" class="form-label">Title</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-tag"></i></span>
            <input type="text" class="form-control" id="title" placeholder="Enter title"
              formControlName="title">
          </div>
        </div>

        <div class="col-4">
          <label for="published-at" class="form-label">Publication date</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-calendar"></i></span>
            <input type="datetime-local" class="form-control" id="published-at"
              formControlName="publishedAt">
          </div>
        </div>

        <div class="col-4">
          <div class="row">
            <div class="col">
              <label for="partner-picture" class="form-label">Picture (466x319)</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-image"></i></span>
                <input type="file" id="partner-picture" class="form-control" (change)="upload($event)">
              </div>
            </div>

            @if (news?.image) {
              <div class="col-auto">
                <div class="profile-picture">
                  <img [ngSrc]="imageService.getImageUrl($safeNavigationMigration(news?.image), 117, 80)" width="117" height="80" alt="News image">
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col-12">
          <label for="excerpt" class="form-label">Excerpt</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-body-text"></i></span>
            <input type="text" class="form-control" id="excerpt" placeholder="Enter excerpt"
              formControlName="excerpt">
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col-12">
          <label for="content" class="form-label">Content</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-textarea"></i></span>
            <textarea class="form-control" id="content" placeholder="Enter main content"
            formControlName="content" rows="7"></textarea>
          </div>
        </div>
      </div>

      <div class="col-12 text-end">
        <button type="submit" class="btn btn-primary fw-bold">
          @if (isCreate()) {
            <span>Create</span>
          }
          @if (!isCreate()) {
            <span>Update</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
